// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"38256538","376":"4a5a0cf2","453":"782296d0"}[chunkId] + ".chunk.js";
};